export const chartFunctionsMixin = {
  data: function() {
    return {
      fullscreen: false,
      loadingData: false,
      showAll: false,
      valueQuantity: false,
      modalDate: false,
      dateFrom: "",
      dateTo: ""
    };
  },
  computed: {
    from() {
      if (typeof this.dateFrom === "object") {
        this.dateFrom = this.dateFrom.toISOString().split("T")[0];
        return this.dateFrom;
      }
      return this.dateFrom;
    },
    to() {
      if (typeof this.dateTo === "object") {
        this.dateTo = this.dateTo.toISOString().split("T")[0];
        return this.dateTo;
      }
      return this.dateTo;
    }
  },
  watch: {
    valueQuantity() {
      this.fetchData();
      if (this.fullScreen) {
        this.$refs.backRef.chart.options.chart.height = "50%";
      } else {
        this.$refs.backRef.chart.options.chart.height = 400;
      }
    }
  },
  methods: {
    toggleFullScreen() {
      this.$fullscreen.toggle(this.$el.querySelector(".backClass"), {
        wrap: false,
        callback: this.fullscreenChange
      });
    },
    modalDateEvent(modal_id) {
      this.exitFullscreen();
      this.$bvModal.show(modal_id);
    },
    exitFullscreen() {
      if (!this.fullscreen) {
        return;
      } else {
        this.toggleFullScreen();
      }
    },
    top10AllDataEmit(disabledAll) {
      this.showAll = disabledAll;
      this.fetchData();
    },

    onDatePickerModalEmit(changedDateFrom, changedDateTo) {
      this.dateFrom = changedDateFrom;
      this.dateTo = changedDateTo;
    },
    fullscreenChange(fullscreen) {
      this.fullscreen = fullscreen;
      if (this.$refs && this.$refs.backRef && this.$refs.backRef.chart) {
        if (this.fullscreen) {
          this.$refs.backRef.chart.options.chart.height = "50%";
        } else {
          this.$refs.backRef.chart.options.chart.height = 400;
        }
        this.$refs.backRef.chart.reflow();
      }
    },
    changeHeight() {
      if (this.$refs && this.$refs.backRef && this.$refs.backRef.chart) {
        if (this.fullscreen) {
          this.$refs.backRef.chart.options.chart.height = "50%";
        } else {
          if (this.$refs.backRef.chart.options) {
            this.$refs.backRef.chart.options.chart.height = 400;
          }
        }
        this.$refs.backRef.chart.reflow();
      }
    },
    downloadPDF() {
      this.$refs.backRef.chart.options.title.text =
        this.title + " | " + this.dateTo;
      this.$refs.backRef.chart.options.title.style.color = "black";
      this.$refs.backRef.chart.options.title.style.display = "block";
      this.$refs.backRef.chart.options.drilldown.activeAxisLabelStyle.color =
        "black";
      this.$refs.backRef.chart.options.xAxis.forEach(obj => {
        obj.labels.style.color = "black";
      });
      this.$refs.backRef.chart.exportChart({
        type: "application/pdf",
        filename: this.title + "-" + this.dateTo
      });
      this.$refs.backRef.chart.options.drilldown.activeAxisLabelStyle.color =
        "white";
    }
  },
  created() {
    let fromDate = new Date();
    fromDate.setDate(fromDate.getDate() - 30);

    this.dateFrom = fromDate.toJSON().slice(0, 10);
    this.dateTo = new Date().toJSON().slice(0, 10);
  }
};
